export const getUploadUrl = (name) =>
	encodeURI(`${process.env.REACT_APP_CDN_URL}/${name}`);
